// extracted by mini-css-extract-plugin
module.exports = {"tabsUl":"tabsUl-1y_9vbe6","current":"current-25Bw7FRa","fix":"fix-2PYpXVaN"};